import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { TaskService } from '@app/_components/task';
import { first } from 'rxjs/operators';
import { concatMap } from 'rxjs/operators';
import { from, of } from 'rxjs';

@Component({
    selector: 'app-onboarding-tasks-dialog',
    templateUrl: './onboarding-tasks-dialog.component.html',
    styleUrls: ['./onboarding-tasks-dialog.component.css'],
    providers: [MessageService],
    standalone: false
})
export class OnboardingTasksDialogComponent implements OnInit {

    propertyProfile: any;
    parentTask: any = null;
    childTasks: any[] = [];
    loading = false;
    creating = false;

    taskStatuses = [
        { value: 2, name: 'Not Started' },
        { value: 1, name: 'In Progress' },
        { value: 0, name: 'Complete' },
        { value: 3, name: 'Blocked' },
        { value: 4, name: 'Cancelled' },
    ];

    private readonly CHILD_TASK_DEFS = [
        {
            title: '1. Owner Information',
            dueDayOffset: 3,
            description: `- [ ] Projected Access Date                         (Day 0)
- [ ] Link to Property on kbmresorts.com            (Day 0)
- [ ] Owner Name                                    (Day 0)
- [ ] Property Ownership Name                       (Day 0)
- [ ] Property Address                              (Day 0)
- [ ] Island                                        (Day 0)
- [ ] Email                                         (Day 0)
- [ ] Phone                                         (Day 0)
- [ ] Mailing Address                               (Day 0)
- [ ] Welcome Email sent to Owner                   (Day 0)
- [ ] Information Sent to Onboarding Team           (Day +3, when live on KBM website)`
        },
        {
            title: '2. Unit Information',
            dueDayOffset: 0,
            description: `- [ ] Prior Owner
- [ ] Prior PM
- [ ] Prior PM Contact
- [ ] TMK Number
- [ ] Region
- [ ] View
- [ ] Floor Number
- [ ] Building Number
- [ ] Stories in Unit
- [ ] Stories in Building
- [ ] Elevator / Stairs
- [ ] Bed / Bath Count
- [ ] Bedrooms with Ensuite Bath
- [ ] Bed Sizes
- [ ] Bath Types
- [ ] Sofa Bed?
- [ ] Sleeps in Bed
- [ ] Sleeps Max
- [ ] Laundry in unit?
- [ ] Living Area (sq ft)
- [ ] Lanai Area (sq ft)
- [ ] Year Built
- [ ] A/C in unit? In all rooms?
- [ ] Any unique property details
- [ ] Property Ranking (Platinum / Gold / Silver / Bronze)
- [ ] Minimum Night Requirement
- [ ] Default Rate`
        },
        {
            title: '3. New Sale Details',
            dueDayOffset: 0,
            description: `- [ ] Financial Contingencies Completed?
- [ ] Physical Property Inspection Completed?`
        },
        {
            title: '4. Future Bookings',
            dueDayOffset: 1,
            description: `- [ ] Owner Dates                                   (Day 0)
- [ ] Guest Dates and Contact Info                  (Day 0)
- [ ] Purchase Addendum with Future Bookings        (Day 0)
- [ ] Dates Blocked for Onboard Prep                (Day +1)
- [ ] Email Guest Services to Contact               (Day +1)`
        },
        {
            title: '5. Photography',
            dueDayOffset: 1,
            description: `- [ ] Photos from Agent or Owner received           (Day 0)
- [ ] Photographer Scheduled / Date                 (Day +1)`
        },
        {
            title: '6. Legal',
            dueDayOffset: 1,
            description: `- [ ] PMA Executed                                  (Day 0)
- [ ] Contract Terms: __% Management Fee            (Day 0)
- [ ] PMA Sent to Mei                               (Day 0)
- [ ] KBM Filing Taxes?                             (Day 0)
- [ ] W9 received                                   (Day 0)
- [ ] SOH County Tax                                (Day 0)
- [ ] MCTAT (Maui only)                             (Day 0)
- [ ] Direct Deposit setup                          (Day 0)
- [ ] GET/TAT Numbers: ___                          (Day 0)
- [ ] TMK Number: ___                               (Day 0)
- [ ] POA N848                                      (Day +1)
- [ ] STVR Permit (Hawaii Island or Kuilima Estates Oahu only)  (Day +1)`
        },
        {
            title: '7. Content',
            dueDayOffset: 2,
            description: `- [ ] Content Requested                             (Day +1)
- [ ] Add "NEW" to listing title for all OTAs       (Day +2)
- [ ] Add TAT, TMK & STR Number to Listing Content  (Day +2)`
        },
        {
            title: '8. Wiki Setup',
            dueDayOffset: 3,
            description: `- [ ] Property Added                                (Day 0)
- [ ] Owner Added                                   (Day 0)
- [ ] Contract Terms Entered                        (Day 0)
- [ ] Settings                                      (Day 0)
- [ ] Address                                       (Day 0)
- [ ] Set Taxes                                     (Day 0)
- [ ] Housekeeping Fee Added                        (Day 0)
- [ ] Resort Fee Added                              (Day 0)
- [ ] Damage Waiver Fee Added                       (Day 0)
- [ ] Free Rental Car Fee Added                     (Day 0)
- [ ] Select Owner in Property Lead Profile         (Day 0)
- [ ] Pushed to Breezeway                           (Day +1)
- [ ] Overview                                      (Day +1)
- [ ] Channels                                      (Day +1)
- [ ] Amenities                                     (Day +1)
- [ ] Rooms                                         (Day +1)
- [ ] Added to Fees Unique Per Unit                 (Day +1)
- [ ] Descriptions                                  (Day +2)
- [ ] Photos                                        (Day +2)
- [ ] Website Resort Page Sort Order                (Day +2)
- [ ] Sync to Yieldmax                              (Day +2)
- [ ] MatterPort (if applicable)                    (Day +3)
- [ ] Create Composite Listing (if applicable)      (Day +3)
- [ ] Google Indexed                                (Day +3)`
        },
        {
            title: '9. Ops Action Items',
            dueDayOffset: 2,
            description: `- [ ] Lock Changed to Kaba                          (Day 0)
- [ ] Reprogram Kaba                                (Day 0)
- [ ] Access Codes and/or Keys Obtained             (Day 0)
- [ ] Lockbox Installed                             (Day 0)
- [ ] WiFi Username                                 (Day 0)
- [ ] WiFi Password                                 (Day 0)
- [ ] Confirm prior PM closed Kaba Account          (Day +1)
- [ ] BEFORE PHOTOS (furniture pen, clean upholstery, magic eraser wall marks)  (Day +1)
- [ ] Manny & Kevin Added as Authorized WiFi Users  (Day +1)
- [ ] Inventory List                                (Day +1)
- [ ] Email to Owner on Missing Inventory           (Day +2)`
        },
        {
            title: '10. Go Live',
            dueDayOffset: 3,
            description: `- [ ] Confirm all future Bookings Entered           (Day +2)
- [ ] Email sent to Set Rates                       (Day +2)
- [ ] Enable Book Online in Wiki                    (Day +3)
- [ ] Tax Numbers Added in RU                       (Day +3)
- [ ] Airbnb live                                   (Day +3)
- [ ] Booking.com live                              (Day +3)
- [ ] Expedia live                                  (Day +3)
- [ ] Google live                                   (Day +3)
- [ ] Marriott live                                 (Day +3)
- [ ] Vrbo live                                     (Day +3)
- [ ] Listing/Owner Portal Sent to Owner            (Day +3)`
        },
        {
            title: '11. President Welcome',
            dueDayOffset: 3,
            description: `- [ ] Sent?  (triggered when official management of the condo starts — NOT when live on website)`
        },
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) data: any,
        private dialogRef: MatDialogRef<OnboardingTasksDialogComponent>,
        private taskService: TaskService,
        private messageService: MessageService,
    ) {
        this.propertyProfile = data.propertyProfile;
        this.parentTask = data.parentTask || null;
        this.childTasks = data.childTasks || [];
    }

    ngOnInit(): void {
        if (this.parentTask) {
            this.loadChildTasks();
        }
    }

    get propertyCode(): string {
        return this.propertyProfile?.propertyCode || this.propertyProfile?.shortTermRentalVO?.propertyCode || '';
    }

    get completedCount(): number {
        return this.childTasks.filter(t => t.status === 0).length;
    }

    get progressPercent(): number {
        if (this.childTasks.length === 0) return 0;
        return Math.round((this.completedCount / this.childTasks.length) * 100);
    }

    getStatusName(status: number): string {
        const s = this.taskStatuses.find(x => x.value === status);
        return s ? s.name : 'Not Started';
    }

    loadChildTasks(): void {
        this.loading = true;
        const filters = { parentTaskId: { value: this.parentTask.taskId, matchMode: 'eq' } };
        this.taskService.findByFilter(0, 20, 'name', 1, null, null, filters).pipe(first()).subscribe(
            (res: any) => {
                this.childTasks = res.data?.tasks || res.data?.taskSummaryList || [];
            },
            (err: any) => {
                console.log('loadChildTasks error: ' + JSON.stringify(err));
            },
            () => { this.loading = false; }
        );
    }

    startOnboarding(): void {
        const code = this.propertyCode;
        if (!code) {
            this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'No property code found.' });
            return;
        }

        this.creating = true;
        const today = new Date();
        const dueDate = new Date(today);
        dueDate.setDate(dueDate.getDate() + 3);

        const parentTaskPayload: any = {
            name: 'Onboarding: ' + code,
            status: 2,
            priority: 4,
            dateDue: dueDate.toISOString(),
            taskType: 7,
            str_1: code,
            int_1: 1,
        };

        this.taskService.add(parentTaskPayload).pipe(first()).subscribe(
            (res: any) => {
                const parent = res.data?.task;
                if (!parent || !parent.taskId) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create parent task.' });
                    this.creating = false;
                    return;
                }
                this.parentTask = parent;
                this.createChildTasksSequentially(parent.taskId, today);
            },
            (err: any) => {
                console.log('startOnboarding parent error: ' + JSON.stringify(err));
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create onboarding task.' });
                this.creating = false;
            }
        );
    }

    private createChildTasksSequentially(parentTaskId: number, accessDate: Date): void {
        const defs = [...this.CHILD_TASK_DEFS];
        const created: any[] = [];

        from(defs).pipe(
            concatMap(def => {
                const due = new Date(accessDate);
                due.setDate(due.getDate() + def.dueDayOffset);
                const child: any = {
                    name: def.title + ' — ' + this.propertyCode,
                    description: def.description,
                    status: 2,
                    priority: 4,
                    dateDue: due.toISOString(),
                };
                return this.taskService.addWithParent(child, parentTaskId);
            })
        ).subscribe(
            (res: any) => {
                if (res.data?.task) {
                    created.push(res.data.task);
                }
            },
            (err: any) => {
                console.log('child task creation error: ' + JSON.stringify(err));
                this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'One or more child tasks failed to create.' });
            },
            () => {
                this.childTasks = created;
                this.creating = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Onboarding tasks created.' });
            }
        );
    }

    onStatusChange(task: any, newStatus: number): void {
        const updated = { ...task, status: newStatus };
        this.taskService.update(updated).pipe(first()).subscribe(
            (res: any) => {
                task.status = newStatus;
                this.messageService.add({ severity: 'success', summary: 'Updated', detail: task.name + ' status updated.', life: 2000 });
            },
            (err: any) => {
                console.log('status update error: ' + JSON.stringify(err));
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update status.' });
            }
        );
    }

    close(): void {
        this.dialogRef.close({ parentTask: this.parentTask });
    }
}
